var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("list-page", {
        attrs: { getter: "purchases" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function() {
              return [_vm._v("\n            Purchased Stock\n        ")]
            },
            proxy: true
          },
          {
            key: "right_buttons",
            fn: function() {
              return [
                _c(
                  "b-btn",
                  {
                    on: {
                      click: function($event) {
                        return _vm.openCreateNichibo()
                      }
                    }
                  },
                  [_vm._v("Add Nichibo Stock")]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("CreateByNichiboStockNo", { ref: "createNichibo" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73309086", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73309086","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleStock/PurchasedStock.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-73309086","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleStock/PurchasedStock.vue
// module chunks = 0